import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_PAYMENT + '/coupon'

const fetch = params => {
	return Repository(baseURL).fetch(params)
}

const count = params => {
	return Repository(baseURL + '/count').fetch(params)
}

const fetchOne = id => {
	return Repository(baseURL).fetchOne(id)
}

const create = params => {
	return Repository(baseURL + '/create').create(params)
}

const update = (id, params) => {
	return Repository(baseURL).update(id, params)
}

const remove = id => {
	return Repository(baseURL).delete(id)
}

const createMany = params => {
	return Repository(baseURL).createMany(params)
}

export default {
	fetch,
	fetchOne,
	create,
	createMany,
	update,
	remove,
	count
}
